












import { defineComponent } from "@vue/composition-api";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageForgotPassword",
  components: { PageTitle, BasePage, BaseButton, BaseInput },
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await providers.PasswordResetProvider.start({ data: { email: this.email } });
      } finally {
        this.$router.push({ name: "loginForgotEmail", params: { email: this.email } });
        this.loading = false;
      }
    },
  },
});
